/* ─────────────────────────────────────────────────────────────
   TULIP BOX ORDERING CUTOFF
   Orders must be placed by 11:59 PM for next-day processing
   and 2-day delivery. After 11:59 PM ordering is disabled.
   Adjust CUTOFF_HOUR / CUTOFF_MINUTE below if the window changes.
   ───────────────────────────────────────────────────────────── */
const CUTOFF_HOUR   = 23; // 11 PM  (24-hour)
const CUTOFF_MINUTE = 59; // :59

function isTulipBoxCutoffReached() {
  // Always evaluate against Eastern Time (EST/EDT) regardless of the
  // customer's local device clock. toLocaleString with timeZone forces
  // the conversion so a customer in California or London gets the same
  // cutoff window as one sitting in New Jersey.
  var estStr = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });
  var est    = new Date(estStr);
  var h      = est.getHours();
  var m      = est.getMinutes();
  return (h > CUTOFF_HOUR) || (h === CUTOFF_HOUR && m >= CUTOFF_MINUTE);
}

function showTulipBoxCutoffMessage() {
  var btns = document.querySelector('.product-form__buttons');
  if (btns) {
    // Calculate next available delivery date (2 days from tomorrow)
    var nextOrder    = new Date();
    nextOrder.setDate(nextOrder.getDate() + 1); // tomorrow = next available order day
    var nextDelivery = new Date(nextOrder);
    nextDelivery.setDate(nextDelivery.getDate() + 2); // +2 days shipping

    var fmt = { weekday: 'long', month: 'long', day: 'numeric' };
    var deliveryStr = nextDelivery.toLocaleDateString('en-US', fmt);

    btns.innerHTML =
      '<div class="min_order_msg cutoff_msg">' +
        'Ordering is closed for tonight. Orders must be placed by 11:59 PM ' +
        'for 2-day delivery. Place your order tomorrow for delivery by ' +
        '<strong>' + deliveryStr + '</strong>.' +
      '</div>';
  }
}
/* ─────────────────────────────────────────────────────────────
   END CUTOFF HELPERS
   ───────────────────────────────────────────────────────────── */


if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        /* ── TULIP BOX CUTOFF CHECK (submit) ── */
        var productHandle = document.querySelector('body').getAttribute('data-current-product-handle');
        if (productHandle === 'tulip-surprise-box' && isTulipBoxCutoffReached()) {
          showTulipBoxCutoffMessage();
          return; // block the add-to-cart entirely
        }
        /* ── END CUTOFF CHECK ── */

        fetch(window.Shopify.routes.root + 'cart.js', {
          method: 'GET'
        })
        .then(response => {
          return response.json();
        })
        .then((response) => {

          /* additional : start */
          var get_current_product_handle = document.querySelector('body').getAttribute('data-current-product-handle');
          var get_current_product_handle_min = document.querySelector('body').getAttribute('data-min-order');
          
          console.log(response);
          console.log(response.items);
          
          response.items.forEach(function (cartArrayItem) {
              console.log(cartArrayItem.handle);
              // Added condition to check if the product type is "Tulip Box"
              if(cartArrayItem.handle == get_current_product_handle && get_current_product_handle_min == "1" && (cartArrayItem.product_type || "").toLowerCase() === "tulip box"){
                document.querySelector('.product-form__buttons').innerHTML = '<div class="min_order_msg">You can only order 1 box at a time</div>';
              }
          });
          /* additional : end */

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {

                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }

              var get_current_product_handle_min = document.querySelector('body').getAttribute('data-min-order');
              
              // Added condition to check if the added item's product type is "Tulip Box"
              if(get_current_product_handle_min == "1" && (response.product_type || "").toLowerCase() === "tulip box"){
                document.querySelector('.product-form__buttons').innerHTML = '<div class="min_order_msg">You can only order 1 box at a time</div>';
              }

            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
            
        })
        .catch((error) => {
          console.error('Error:', error);
        });

      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


// Runs on page load to check if the item is already in the cart
fetch(window.Shopify.routes.root + 'cart.js', {
  method: 'GET'
})
.then(response => {
  return response.json();
})
.then((response) => {
  var get_current_product_handle = document.querySelector('body').getAttribute('data-current-product-handle');
  
  console.log(response);
  console.log(response.items);
  
  response.items.forEach(function (cartArrayItem) {
      console.log(cartArrayItem.handle);
      // Added condition to check if the product type is "Tulip Box"
      if(cartArrayItem.handle == get_current_product_handle && (cartArrayItem.product_type || "").toLowerCase() === "tulip box"){
        document.querySelector('.product-form__buttons').innerHTML = '<div class="min_order_msg">You can only order 1 box at a time</div>';
      }
  });

  /* ── TULIP BOX CUTOFF CHECK (page load) ──
     Runs after the cart check so it can override it if needed.
     If it's past 11:59 PM, replace the button with the cutoff message
     regardless of cart state.                                       */
  var pageProductHandle = document.querySelector('body').getAttribute('data-current-product-handle');
  if (pageProductHandle === 'tulip-surprise-box' && isTulipBoxCutoffReached()) {
    showTulipBoxCutoffMessage();
  }
  /* ── END CUTOFF CHECK ── */

})
.catch((error) => {
  console.error('Error:', error);
});